import React, { useState } from 'react'
import Popup from '../Popup'
import TaskForm from '../todo-forms/TaskForm'

const CreateTodo = () => {
    const [showForm, setShowForm] = useState(false)

    const handleClosePopup = () => {
        setShowForm(false)
    }

    return (
        <div>
            <button onClick={() => setShowForm(true)}>Create New</button>
            {
                showForm && 
                <Popup title="Create Todo" setClose={handleClosePopup}>
                    <TaskForm onSubmitForm={handleClosePopup}/>
                </Popup>
            }
        </div>
    )
}

export default CreateTodo